import type { ReactNode } from "react";
import fundingLogos from "../../../img/news/eu-snn-jtf.png?url";

type NewsItem = {
  id: string;
  dateline: string;
  title: string;
  body: ReactNode;
  image?: { src: string; alt: string };
};

const NEWS: NewsItem[] = [
  // Subsidy publication duty (SNN/JTF): EU emblem, JTF mention and SNN logo must
  // stay visible for as long as the VIA project runs. Do not remove or trim.
  {
    id: "via-subsidie",
    dateline: "Groningen, februari 2026",
    title: "VIA Bodematlas – Data en AI ondersteunen versnelling bouwprojecten",
    body: (
      <>
        <p className="font-semibold">
          Het project Bodematlas ontvangt een VIA-subsidie. Bodematlas werkt aan een slimmer en
          sneller voortraject voor locatieontwikkeling.
        </p>
        <p>
          Binnen het project ontwikkelen we een digitaal platform dat openbare locatiegegevens uit
          verschillende bronnen samenbrengt en met behulp van geografische analyses en generatieve
          AI vertaalt naar bruikbare inzichten en rapportages.
        </p>
        <p>
          Binnen het project wordt onderzocht hoe AI kan worden ingezet om bijvoorbeeld een
          QuickScan van een ontwikkellocatie grotendeels automatisch samen te stellen. Het doel is
          om het vaak tijdrovende voortraject van gebieds- en vastgoedontwikkeling efficiënter te
          maken en zo besluitvorming en uiteindelijk ook bouwprojecten te versnellen.
        </p>
        <p>
          Het project moet leiden tot een werkend minimum viable product (MVP) dat samen met
          potentiële gebruikers verder kan worden getest en doorontwikkeld.
        </p>
        <p>
          Dit project wordt mede mogelijk gemaakt door de Europese Unie via het Just Transition Fund
          (JTF) en het Samenwerkingsverband Noord-Nederland (SNN).
        </p>
      </>
    ),
    image: {
      src: fundingLogos,
      alt: "Medegefinancierd door de Europese Unie – Samenwerkingsverband Noord-Nederland (SNN) – Just Transition Fund (JTF)",
    },
  },
];

export const NewsSection = () => (
  <section id="nieuws" className="bg-slate-50 border-t border-slate-200">
    <div className="mx-auto max-w-6xl px-4 py-14">
      <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">Nieuws</h2>

      <div className="mt-10 space-y-6">
        {NEWS.map((item) => (
          <article
            key={item.id}
            id={`nieuws-${item.id}`}
            className="grid gap-8 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 lg:grid-cols-[3fr_2fr] lg:items-center"
          >
            <div>
              <div className="text-xs text-slate-500">{item.dateline}</div>
              <h3 className="mt-1 text-xl font-semibold">{item.title}</h3>
              <div className="mt-4 space-y-4 text-slate-700 leading-relaxed">{item.body}</div>
            </div>
            {item.image && (
              <img className="w-full max-w-md" src={item.image.src} alt={item.image.alt} />
            )}
          </article>
        ))}
      </div>
    </div>
  </section>
);
